import { render, staticRenderFns } from "./performance-report.vue?vue&type=template&id=1571dbae&scoped=true&"
import script from "./performance-report.vue?vue&type=script&lang=js&"
export * from "./performance-report.vue?vue&type=script&lang=js&"
import style0 from "./performance-report.vue?vue&type=style&index=0&id=1571dbae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1571dbae",
  null
  
)

export default component.exports